// extracted by mini-css-extract-plugin
export default {"background":"TempoBoxBanner-module_background_htVzbvacWa"};